import * as React from 'react';
type Props = {
  className?: string;
};
export function MealTypes({ className }: Props) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-MealTypes"
      className={className}
    >
      <path
        d="M6.87403 59.5957L6.87396 59.5956C5.55844 56.7604 5 54.1622 5 51.7421C5 44.3945 10.1527 38.5179 15.6843 32.5025C15.8724 32.298 16.0609 32.0934 16.2495 31.8885C18.8117 29.1062 21.405 26.2901 23.4804 23.3116C25.7123 20.1084 27.3714 16.6825 27.7596 12.8513C28.177 8.73268 30.5478 6.15697 34.0482 4.90311C37.5831 3.63685 42.283 3.72144 47.2546 5.03579C57.2013 7.66543 67.9808 15.1466 72.2804 25.9359C80.9035 47.5744 67.2558 66.2603 55.7283 72.9941C50.0203 76.3283 40.1236 78.0263 30.4657 76.3396C20.8236 74.6557 11.5209 69.6183 6.87403 59.5957Z"
        fill="#D6E4EE"
        stroke="currentColor"
      />
      <path
        d="M39.5982 60.072C28.1747 60.072 18.9141 51.0028 18.9141 39.8153C18.9141 28.6278 28.1747 19.5586 39.5982 19.5586C51.0217 19.5586 60.2823 28.6278 60.2823 39.8153C60.2823 51.0028 51.0217 60.072 39.5982 60.072Z"
        fill="white"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5976 53.067C47.0706 53.067 53.1287 47.1341 53.1287 39.8155C53.1287 32.4969 47.0706 26.564 39.5976 26.564C32.1245 26.564 26.0664 32.4969 26.0664 39.8155C26.0664 47.1341 32.1245 53.067 39.5976 53.067Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.9805 22.8433V60.4412"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.751 36.8225C14.6122 36.8225 16.9316 33.5897 16.9316 29.6018C16.9316 25.6139 14.6122 22.3811 11.751 22.3811C8.88975 22.3811 6.57031 25.6139 6.57031 29.6018C6.57031 33.5897 8.88975 36.8225 11.751 36.8225Z"
        fill="white"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.752 59.9005V36.8225"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.4297 22.8433V30.9138C62.4297 33.4163 64.3652 35.4449 66.7528 35.4449H67.1068C69.4943 35.4449 71.4298 33.4163 71.4298 30.9138V22.8433"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
